<template>
  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <h3 class="font-light m-b-xs">
            My Documents
          </h3>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="row">
        <div class="col-xs-12">
          <my-documents ref="myDocuments"></my-documents>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import MyDocuments from '../../components/documents/MyDocuments'

export default {
  name: 'Documents',
  components: {MyDocuments}
}
</script>



// WEBPACK FOOTER //
// src/pages/document/Documents.vue